import { DragDropContext } from "@hello-pangea/dnd";
import { AddIcon, Alert, Button, Skeleton, Stack } from "@all-manager/design-system-v2";
import AddIncidentActionModal from "../actionModales/AddIncidentActionModal/AddIncidentActionModal";
import EditIncidentModal from "./EditIncidentModal/EditIncidentModal";
import IncidentKanbanColumn from "./IncidentKanbanColumn/IncidentKanbanColumn";
import { useIncidentsTab } from "./useIncidentsTab";

type Props = {
  subTopicId: string;
};

export default function IncidentsTab(props: Props) {
  const {
    isAdmin,
    ongoingIncidents,
    resolvedIncidents,
    isLoading,
    error,
    isNewModalOpen,
    selectedIncidentToEdit,
    handleDragEnd,
    handleStatusChange,
    handleOpenNewModal,
    handleCloseNewModal,
    handleOpenEditModal,
    handleCloseEditModal,
  } = useIncidentsTab(props);

  if (isLoading) {
    return (
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} aria-busy="true" aria-label="Chargement des incidents">
        <Skeleton variant="rounded" height={240} width="100%" />
        <Skeleton variant="rounded" height={240} width="100%" />
      </Stack>
    );
  }

  if (error) {
    return (
      <Alert severity="error">
        Les incidents n&apos;ont pas pu être chargés. Rechargez la page pour réessayer.
      </Alert>
    );
  }

  return (
    <Stack spacing={2}>
      {isAdmin ? (
        <Stack direction="row" justifyContent="flex-end" alignItems="center">
          <Button
            variant="outlined"
            size="small"
            startIcon={<AddIcon fontSize="small" />}
            onClick={handleOpenNewModal}
          >
            Signaler un incident
          </Button>
        </Stack>
      ) : null}

      <DragDropContext onDragEnd={handleDragEnd}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} alignItems="stretch">
          <IncidentKanbanColumn
            droppableId="in_progress"
            title="En cours"
            incidents={ongoingIncidents}
            isResolvedColumn={false}
            onStatusChange={isAdmin ? handleStatusChange : undefined}
            onEdit={isAdmin ? handleOpenEditModal : undefined}
            onAddIncident={isAdmin ? handleOpenNewModal : undefined}
          />

          <IncidentKanbanColumn
            droppableId="resolved"
            title="Terminés"
            incidents={resolvedIncidents}
            isResolvedColumn={true}
            onStatusChange={isAdmin ? handleStatusChange : undefined}
            onEdit={isAdmin ? handleOpenEditModal : undefined}
          />
        </Stack>
      </DragDropContext>

      {isNewModalOpen ? (
        <AddIncidentActionModal
          onClose={handleCloseNewModal}
          subjectId={props.subTopicId}
        />
      ) : null}

      {selectedIncidentToEdit ? (
        <EditIncidentModal
          incident={selectedIncidentToEdit}
          subjectId={props.subTopicId}
          onClose={handleCloseEditModal}
        />
      ) : null}
    </Stack>
  );
}
